import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }, { height }: { height: number }) => {
  return {
    container: css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: ${height}px;
    `,
    title: css`
      margin-top: 12px;
      text-align: center;
    `
  };
});
